let config = {
  apiUrl: 'https://tryascend.com/api',
  baseUrl: 'https://portal.tryascend.com',
  domain: 'tryascend.auth0.com',
  clientId: 'hrXk6DVL5hAiSvNylq8vneUGsjKPkSND',
  callbackUrl: 'https://portal.tryascend.com/callback',
  captchaKey: '6LfnXX4UAAAAAPcZvwuS85grtGqkhZvWCETnVIJV',
  squareAppId: 'sq0idp-rRLry7K24dfywcjePyuffg',
};

const devConfig = {
  apiUrl: 'http://tryascend.localhost/api', // for local MySql
  baseUrl: 'http://localhost:3000',
  callbackUrl: `http://localhost:3000/callback`,
  squareAppId: 'sandbox-sq0idp-rRLry7K24dfywcjePyuffg',
};

if (process.env.NODE_ENV === 'development') {
  config = { ...config, ...devConfig };
}

export default config;
